import React from 'react';
import { connect } from 'react-redux';
import {
  DetailsListLayoutMode,
  DetailsRow,
  Dropdown,
  Fabric,
  IColumn,
  IDetailsFooterProps,
  IDetailsListProps,
  IDetailsRowStyles,
  ScrollablePane,
  ScrollbarVisibility,
  SelectionMode,
  ShimmeredDetailsList,
  Sticky,
  StickyPositionType,
  Text,
  TextField,
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { ListPaneItem, ProjectBreakdown } from '../../../types/projectBreakdownStructure';
import { InvoiceListPaneFilter } from '../../../types/invoice';
import { formatDate, getProject } from '../../../shared/util';
import CustomDatePicker from '../../../shared/customDatePicker/customDatePicker';

export const classNames = mergeStyleSets({
  wrapper: {
    height: 'calc(100vh - 280px)!important',
    position: 'relative',
  },
  filter: {
    paddingBottom: 20,
    maxWidth: 100,
  },
  header: {
    margin: 0,
  },
  row: {
    display: 'inline-block',
  },
});

const ListPaneComponent = (props: {
  filter: InvoiceListPaneFilter;
  selection: any;
  columns: IColumn[];
  listPaneItems: ListPaneItem[];
  resourceTypes: [];
  handleListPaneItemClick: (id: string) => void;
  handleFilterChange: (filter: InvoiceListPaneFilter) => void;
  isDataLoaded?: boolean;
  loadMsg: string;
  resetSelection: () => void;
  formData: ProjectBreakdown;
  dropDownOptions: any;
}) => {

  const getDropdownWithDefualt = (options: any) => {
    if (options) {
      let defualtOption = [
        {
          key: '0',
          text: t('all'),
          isDefault: true,
        },
      ];
      Array.prototype.push.apply(defualtOption, options);
      return defualtOption;
    } else {
      return [];
    }
  };

  const _onRenderRow: IDetailsListProps['onRenderRow'] = (row) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (row) {
      return (
        <span
          style={{ textDecoration: 'none' }}
          onClick={() => {
            props.handleListPaneItemClick(row.item.invoiceId);
          }}
        >
          <DetailsRow {...row} styles={customStyles}/>
        </span>
      );
    }
    return null;
  };


  const _onRenderDetailsFooter = (
    detailsFooterProps: IDetailsFooterProps | undefined,
  ) => {
    if (getProject()) {
      return (
        <DetailsRow
          className="footer-as-filter"
          {...detailsFooterProps}
          columns={detailsFooterProps?.columns}
          item={{}}
          itemIndex={-1}
          groupNestingDepth={detailsFooterProps?.groupNestingDepth}
          selection={detailsFooterProps?.selection}
          onRenderItemColumn={_renderFilterItemColumn}
          // onRenderCheck={_onRenderCheckForFooterRow}
        />
      );
    } else {
      return (
        <DetailsRow
          className="footer-as-filter"
          {...detailsFooterProps}
          columns={detailsFooterProps?.columns}
          item={{}}
          itemIndex={-1}
          groupNestingDepth={detailsFooterProps?.groupNestingDepth}
          selection={detailsFooterProps?.selection}
          onRenderItemColumn={_renderFilterItemColumnCu}
          // onRenderCheck={_onRenderCheckForFooterRow}
        />
      );
    }

  };

  const _renderFilterItemColumn = (
    item?: ListPaneItem,
    index?: number,
    column?: IColumn,
  ) => {
    switch (column?.key) {

      case 'column1': {
        return (
          <div>
            <TextField
              value={props.filter.title ? props.filter.title : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.title = value;
                } else {
                  props.filter.title = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column2': {
        return (
          <div>
            <TextField
              value={props.filter.totalExcludingTax ? props.filter.totalExcludingTax.toString() : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.totalExcludingTax = value;
                } else {
                  props.filter.totalExcludingTax = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column3': {
        return (
          <div>
            <TextField
              value={props.filter.totalIncludingTax ? props.filter.totalIncludingTax.toString() : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.totalIncludingTax = value;
                } else {
                  props.filter.totalIncludingTax = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column4': {
        return (
          <div>
            <CustomDatePicker
              setMinDate={null}
              setMaxDate={null}
              setValue={formatDate(props.filter.date, 1)}
              getValue={(date: Date) => {
                //onChangeEndDateTime(formatDate(date, 2));
                if (date) {
                  props.filter.date = formatDate(date, 2);
                } else {
                  props.filter.date = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column5': {
        return (
          <div>
            <Dropdown
              placeholder={t('status')}
              options={getDropdownWithDefualt(props.dropDownOptions.status)}
              selectedKey={props.filter.invoiceStatusId ? props.filter.invoiceStatusId : '0'}
              onChange={(event, value) => {
                if (value) {
                  props.filter.invoiceStatusId =
                    value.key != 0 ? value.key.toString() : null;
                } else {
                  props.filter.invoiceStatusId = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      default: {
        break;
      }
    }
  };

  const _renderFilterItemColumnCu = (
    item?: ListPaneItem,
    index?: number,
    column?: IColumn,
  ) => {
    switch (column?.key) {

      case 'column1': {
        return (
          <div>
            <TextField
              value={props.filter.projectSequenceCode ? props.filter.projectSequenceCode : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.projectSequenceCode = value;
                } else {
                  props.filter.projectSequenceCode = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column2': {
        return (
          <div>
            <TextField
              value={props.filter.title ? props.filter.title : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.title = value;
                } else {
                  props.filter.title = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column3': {
        return (
          <div>
            <TextField
              value={props.filter.totalExcludingTax ? props.filter.totalExcludingTax.toString() : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.totalExcludingTax = value;
                } else {
                  props.filter.totalExcludingTax = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column4': {
        return (
          <div>
            <TextField
              value={props.filter.totalIncludingTax ? props.filter.totalIncludingTax.toString() : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.totalIncludingTax = value;
                } else {
                  props.filter.totalIncludingTax = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column5': {
        return (
          <div>
            <CustomDatePicker
              setMinDate={null}
              setMaxDate={null}
              setValue={formatDate(props.filter.date, 1)}
              getValue={(date: Date) => {
                //onChangeEndDateTime(formatDate(date, 2));
                if (date) {
                  props.filter.date = formatDate(date, 2);
                } else {
                  props.filter.date = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      case 'column6': {
        return (
          <div>
            <Dropdown
              placeholder={t('status')}
              options={getDropdownWithDefualt(props.dropDownOptions.status)}
              selectedKey={props.filter.invoiceStatusId ? props.filter.invoiceStatusId : '0'}
              onChange={(event, value) => {
                if (value) {
                  props.filter.invoiceStatusId =
                    value.key != 0 ? value.key.toString() : null;
                } else {
                  props.filter.invoiceStatusId = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }
      default: {
        break;
      }
    }
  };


  const { t } = useTranslation();

  const displayMessage = () => {
    return (
      <div style={{ paddingTop: 36, paddingLeft: 20 }}>
        <Text>{t(props.loadMsg)}</Text>
      </div>
    );
  };
  return (
    <Fabric>
      <div className={`wrapper-holder ${classNames.wrapper}`}>
        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
          <ShimmeredDetailsList
            items={props.listPaneItems}
            columns={props.columns}
            setKey="set"
            enableShimmer={!props.isDataLoaded}
            layoutMode={DetailsListLayoutMode.justified}
            selectionPreservedOnEmptyClick={true}
            checkboxVisibility={1}
            onRenderRow={_onRenderRow}
            onRenderDetailsFooter={_onRenderDetailsFooter}
            selection={props.selection}
            selectionMode={SelectionMode.single}
            ariaLabelForSelectionColumn="Toggle selection"
            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
            checkButtonAriaLabel="Row checkbox"
            onRenderDetailsHeader={(headerProps, defaultRender) => {
              if (defaultRender !== undefined) {
                return (
                  <Sticky
                    stickyPosition={StickyPositionType.Header}
                    isScrollSynced={true}
                    stickyBackgroundColor="transparent"
                  >
                    <div>{defaultRender(headerProps)}</div>
                  </Sticky>
                );
              } else {
                return <span></span>;
              }
            }}
          />
          {props.isDataLoaded && displayMessage()}
        </ScrollablePane>
      </div>
    </Fabric>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    toleranceStatesFilter: state.projectBreakdown.toleranceStatesFilter,
    productStatesFilter: state.projectBreakdown.productStatesFilter,
    itemTypesFilter: state.projectBreakdown.itemTypesFilter,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ListPaneComponent);
